/* eslint-disable @typescript-eslint/no-explicit-any */
// export const Callable = <TConstructor extends Constructor>(t: TConstructor) =>
//     t as CallableConstructor<TConstructor>;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function Callable(type) {
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    function constructor(...args) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return new type(...args);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    constructor.prototype = type.prototype;
    // TODO: Overwrite static values dynamically.
    constructor.utils = type.utils;
    constructor.asset = type.asset;
    constructor.chain = type.chain;
    return constructor;
}
//# sourceMappingURL=callableClass.js.map